import { render } from "./GameDisgaea2.vue?vue&type=template&id=f614795a&scoped=true"
import script from "./GameDisgaea2.vue?vue&type=script&lang=js"
export * from "./GameDisgaea2.vue?vue&type=script&lang=js"

import "./GameDisgaea2.vue?vue&type=style&index=0&id=f614795a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f614795a"]])

export default __exports__